export const reportsGmt = {
    namespaced: true,

    state: {
        filter: {
            athletes: [],
            crewStructuresIds: [],
            tags: [],
            speedIntensities: [],
            srIntensities: [],
            focuses: []
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        }
    },

    mutations: {
        setAthletes(state, athletes) {
            state.filter.athletes = athletes;
        },

        setTags(state, tags) {
            state.filter.tags = tags;
        },

        setBoatType(state, payload) {
            state.filter.crewStructuresIds = payload;
        },

        setSpeedIntensity(state, payload) {
            state.filter.speedIntensities = payload;
        },

        setSrIntensity(state, payload) {
            state.filter.srIntensities = payload;
        },

        setFocuses(state, payload) {
            state.filter.focuses = payload;
        }
    }
};

export default reportsGmt;
